import {
    ApiBaseService,
    type EnhancedFetchOptions,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "./ApiBaseService";
import type { ExternalObject } from "~/models/ExternalObject";
import type { ApiResponse } from "~/types/ApiResponse";

export default class ExternalObjectService extends ApiBaseService {
    public simpleList(
        options: Record<string, any> = {},
    ): Promise<ApiResponse<ExternalObject>> {
        return this.request(
            this.route("api.external_objects.fields", "/external_objects"),
            {
                method: "GET",
                params: {
                    ...options,
                    pagination: "none",
                },
            },
        );
    }

    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<ExternalObject> {
        return this.paginate<ExternalObject>(
            this.route("api.external_objects.index", "/external_objects"),
            options as PaginatedFetchOptions,
        );
    }

    public create(
        data?: Partial<ExternalObject>,
    ): Promise<ApiResponse<ExternalObject>> {
        return this.request(
            this.route("api.external_objects.store", "/external_objects"),
            {
                method: "POST",
                body: data,
            },
        );
    }

    public syncForConnection(
        connection_id: string,
        data?: Partial<ExternalObject>,
    ) {
        return this.request(
            this.route(
                "api.external_objects.syncForConnection",
                "/external_objects/{connection_id}/sync",
                { connection_id },
            ),
            {
                method: "POST",
                body: data,
            },
        );
    }

    public find(
        id: number,
        options?: EnhancedFetchOptions,
    ): Promise<ApiResponse<ExternalObject>> {
        return this.request(
            this.route("api.external_objects.show", "/external_objects/{id}", {
                id,
            }),
            options,
        );
    }

    public update(
        id: number,
        data: Partial<ExternalObject>,
    ): Promise<ApiResponse<ExternalObject>> {
        return this.request(
            this.route("api.external_objects.store", "/external_objects/{id}", {
                id,
            }),
            {
                method: "PATCH",
                body: data,
            },
        );
    }

    public delete(id: number): Promise<null> {
        return this.request(
            this.route(
                "api.external_objects.destroy",
                "/external_objects/{id}",
                { id },
            ),
            {
                method: "DELETE",
            },
        );
    }
}
